const MuiTabs = {
  textColor: 'primary'
};
export default MuiTabs;